import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component,  Inject, Input, OnDestroy, OnInit, PLATFORM_ID, input } from '@angular/core';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { Partner } from '@app/models/partner/IPartner';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { Subject, takeUntil } from 'rxjs';
interface Item {
    code: string;
    name: string;
}

@Component({
    selector: 'clever-verpflegung',
    templateUrl: './verpflegung.component.html',
    styleUrls: ['./verpflegung.component.scss'],
    standalone: false
})
export class VerpflegungComponent implements OnInit, OnDestroy {
    protected unsubscribe$ = new Subject();
    readonly mode = input<string>(undefined);
    readonly partner = input<Partner>(undefined);
    @Input() boardTypeList: Item [];
    isBrowser: boolean = false;
    ohneVerpflegung: boolean = false;
    frustuck: boolean = false;
    halbpension: boolean = false;
    vollpension: boolean = false;
    allinclusive: boolean = false;
    slicenbr: number = 5;
    selectedList: string[] = [];
    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
        }
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    selectohneVerpflegung() {
        this.ohneVerpflegung = !this.ohneVerpflegung;
        this.cdr.detectChanges();
        this.hotelService.boardTypeList({
            code: 'OV',
            name: 'Ohne Verpflegung',
        }, this.ohneVerpflegung, this.mode() !== 'home');
    }

    selectfrustuck() {
        this.frustuck = !this.frustuck;
        this.cdr.detectChanges();
        this.hotelService.boardTypeList({
            code: 'UF',
            name: 'Frühstück',
        }, this.frustuck, this.mode() !== 'home');
    }

    selecthalbpension() {
        this.halbpension = !this.halbpension;
        this.cdr.detectChanges();
        this.hotelService.boardTypeList({
            code: 'HP',
            name: 'Halbpension',
        }, this.halbpension, this.mode() !== 'home');
    }

    selectvollpension() {
        this.vollpension = !this.vollpension;
        this.cdr.detectChanges();
        this.hotelService.boardTypeList({
            code: 'VP',
            name: 'Vollpension',
        }, this.vollpension, this.mode() !== 'home');
    }

    selectallinclusive() {
        this.allinclusive = !this.allinclusive;
        this.cdr.detectChanges();
        this.hotelService.boardTypeList({
            code: 'AI',
            name: 'All Inclusive',
        }, this.allinclusive, this.mode() !== 'home');
    }

    initFilterSub(): void {
        this.hotelService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: ParamFilters) => {
            this.ohneVerpflegung = false;
            this.frustuck = false;
            this.halbpension = false;
            this.vollpension = false;
            this.allinclusive = false;
            this.selectedList = [];
            this.cdr.detectChanges();
            for (let i = 0; i < filter.boardTypeList?.length; i++) {
                this.selectedList.push(filter.boardTypeList[i].code);
                if (filter.boardTypeList[i].code === 'OV') {
                    this.ohneVerpflegung = true;
                    this.cdr.detectChanges();
                }
                if (filter.boardTypeList[i].code === 'UF') {
                    this.frustuck = true;
                    this.cdr.detectChanges();
                }
                if (filter.boardTypeList[i].code === 'HP') {
                    this.halbpension = true;
                    this.cdr.detectChanges();
                }
                if (filter.boardTypeList[i].code === 'VP') {
                    this.vollpension = true;
                    this.cdr.detectChanges();
                }
                if (filter.boardTypeList[i].code === 'AI') {
                    this.allinclusive = true;
                    this.cdr.detectChanges();
                }
            }
            this.cdr.detectChanges();
        });
    }

    sortArray(array): any[] {
        if (array?.length > 0) {
            array?.sort((a, b) => {
                a = a.name.toLowerCase();
                b = b.name.toLowerCase();

                return a < b ? -1 : a > b ? 1 : 0;
            });
        }
        return array;
    }

    showMore(all) {
        this.slicenbr = all;
    }

    selected(op): void {
        let push = true;
        if (this.selectedList.indexOf(op.code) >= 0) {
            push = false;
        }
        this.hotelService.boardTypeList(op, push, true);
        this.cdr.detectChanges();
    }
}

/*
{
            code: 'OV',
            name: 'Ohne Verpflegung',
            checked: false
        },
        {
            code: 'UF',
            name: 'Frühstück',
            checked: false
        },
        {
            code: 'HP',
            name: 'Halbpension',
            checked: false
        },
        {
            code: 'VP',
            name: 'Vollpension',
            checked: false
        },
        {
            code: 'AI',
            name: 'All Inclusive',
            checked: false
        }
*/
